import axios from 'axios'

import store from '../store'

import Cookies from 'js-cookie'

// create an axios instance
const service = axios.create({
  baseURL: '/sapi', // url = base url + request url
  withCredentials: true // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use( 
  config => {
    // do something before request is sent

    // const token = store.state.token || localStorage.accessToken
    const token = Cookies.get('SESSION', { path: '/' })
    if (token) {
      config.headers['x-auth-token'] = token
    }
    // config.headers['system-code'] = 'xbjj'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // 下载文件
    if (response.headers['content-disposition']) {
      return response
    }
    if (response.headers['Content-Disposition']) {
      return response
    }
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    // console.log(res )
    if (res.code !== 20000 && res.code !== 0) {
      let msg = ''
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.code === 401) { msg = '您已登出，可以取消留在此页，或重新登录' } else if (res.code === 50009) { msg = '会话超时，请重新登录' }

      if (msg) {

      } else {

      }
      return Promise.reject(res.message || 'error')
    } else {
      // debugger
      // if(res.code == 0){
      //   return  res
      // }
      return res.data
    }
  },
  error => {
    if (error.message === 'Network Error') {
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    } else {
      return Promise.reject(error)
    }
  }
)

export default service
